import request from '#/utils/request';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

export async function fetchInventoryStockDetail(id) {
  const { data: raw } = await request.get(`/inv/inventory-stock/${id}`);
  return parseVer4DetailResponse(raw);
}
